export class ConfirmDialog extends HTMLElement {
  private resolve: ((value: boolean) => void) | null = null;

  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
  }

  connectedCallback(): void {
    this.shadowRoot!.innerHTML = `
      <style>
        :host { display: none; }
        :host(.visible) { display: block; }
        .overlay {
          position: fixed;
          inset: 0;
          background: rgba(0,0,0,.45);
          z-index: 200;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 16px;
        }
        .dialog {
          background: var(--color-surface, #fff);
          border-radius: 16px;
          padding: 24px;
          max-width: 360px;
          width: 100%;
          box-shadow: 0 8px 32px rgba(0,0,0,.2);
        }
        .dialog-title {
          font-size: 1.125rem;
          font-weight: 600;
          margin: 0 0 8px;
        }
        .dialog-message {
          font-size: .875rem;
          color: var(--color-on-surface-muted, #666);
          margin: 0 0 24px;
          line-height: 1.5;
        }
        .dialog-actions {
          display: flex;
          justify-content: flex-end;
          gap: 8px;
        }
        .dialog-btn {
          padding: 8px 20px;
          border: none;
          border-radius: 8px;
          font-size: .875rem;
          font-weight: 500;
          cursor: pointer;
        }
        .dialog-btn-cancel {
          background: var(--color-surface-container, #eee);
          color: var(--color-on-surface, #333);
        }
        .dialog-btn-confirm {
          background: var(--color-error, #d32f2f);
          color: #fff;
        }
      </style>
      <div class="overlay">
        <div class="dialog">
          <p class="dialog-title"></p>
          <p class="dialog-message"></p>
          <div class="dialog-actions">
            <button class="dialog-btn dialog-btn-cancel" id="cancel-btn">Anuluj</button>
            <button class="dialog-btn dialog-btn-confirm" id="confirm-btn">Potwierdź</button>
          </div>
        </div>
      </div>
    `;

    this.shadowRoot!.querySelector('#cancel-btn')!.addEventListener('click', () => this.close(false));
    this.shadowRoot!.querySelector('#confirm-btn')!.addEventListener('click', () => this.close(true));
    this.shadowRoot!.querySelector('.overlay')!.addEventListener('click', (e) => {
      if (e.target === e.currentTarget) this.close(false);
    });
  }

  show(title: string, message: string, confirmLabel = 'Potwierdź'): Promise<boolean> {
    this.shadowRoot!.querySelector('.dialog-title')!.textContent = title;
    this.shadowRoot!.querySelector('.dialog-message')!.textContent = message;
    this.shadowRoot!.querySelector('#confirm-btn')!.textContent = confirmLabel;
    this.classList.add('visible');

    return new Promise<boolean>((resolve) => {
      this.resolve = resolve;
    });
  }

  private close(result: boolean): void {
    this.classList.remove('visible');
    this.resolve?.(result);
    this.resolve = null;
  }
}

customElements.define('confirm-dialog', ConfirmDialog);

// Singleton helper
let dialogInstance: ConfirmDialog | null = null;

export function confirmDialog(title: string, message: string, confirmLabel?: string): Promise<boolean> {
  if (!dialogInstance) {
    dialogInstance = document.createElement('confirm-dialog') as ConfirmDialog;
    document.body.appendChild(dialogInstance);
  }
  return dialogInstance.show(title, message, confirmLabel);
}
